import {useEffect, useState} from "react";
import useData from "../../../hooks/useData";
import {capitalize} from "../../../helper/tools";

export default function ViewCorrespondentInfos({
    correspondent,
    deceasedInfos,
    adminInfos,
    legend,
}) {
    const [ data, setData ] = useState([]);
    const { countryList } = useData();

    useEffect(() => {
        const hasCorrespondent = correspondent?.firstName || correspondent?.lastName;
        setData(hasCorrespondent ? correspondent : adminInfos)
    }, [ correspondent, adminInfos, countryList ]);

    const addressLine = [
        data?.address?.address,
        data?.address?.comp,
    ].filter(Boolean).join(', ') + (data?.address?.zipcode || data?.address?.city ?
        ` - ${[data?.address?.zipcode, data?.address?.city].filter(Boolean).join(' ')}` : '');

    const nameLine = [
        data?.civility === "MME" ? "Madame" : "Monsieur",
        capitalize(data?.firstName),
        data?.lastName?.toUpperCase()
    ].filter(Boolean).join(' ');

    if (!data?.firstName && !data?.lastName) {
        return null;
    }

    return (
        <fieldset>
            <legend>{legend}</legend>
            <div className="recap-summary">
                <p className="recap-name">{nameLine}</p>
                <p className="recap-address"><span>Adresse : </span>{addressLine}</p>
            </div>
        </fieldset>
    )
}
